import { useState } from 'react'
import Button from '../atoms/Button'
import ViewButton from '../atoms/ViewButton'
import css from './MultipleViews.module.scss'

export default function MultipleViews({
	tableView,
	gridView,
	defaultView,
	emptyView,
	isEmpty,
	showControls = false,
	searchBar,
	setView,
	view,
	isLocked,
	lockedView,
}) {
	// const [view, setView] = useState(defaultView) // "table" or "grid"

	return !isLocked ? (
		<>
			{showControls ? (
				<>
					<div className={css['controls']}>
						<ViewButton
							label='Table'
							onClick={() => setView('table')}
							isSelected={view === 'table'}
							icon='table'
						/>
						<ViewButton
							label='Cards'
							onClick={() => setView('grid')}
							isSelected={view === 'grid'}
							icon='grip-horizontal'
						/>
					</div>
					{searchBar}
					{!isEmpty && view === 'table' && tableView}
					{!isEmpty && view === 'grid' && gridView}
				</>
			) : null}

			{isEmpty && emptyView}
		</>
	) : (
		isLocked && lockedView
	)
}
